"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _serializr = require("serializr");
var _mobx = require("mobx");
var _lodash = require("lodash");
var _utils = require("@seedlang/utils");
var _root_model = _interopRequireDefault(require("./root_model"));
var _user = _interopRequireDefault(require("./user"));
var _comment = _interopRequireDefault(require("./comment"));
var _date_decorator = _interopRequireDefault(require("./date_decorator"));
var _worksheet_basic = _interopRequireDefault(require("./worksheet_basic"));
var _word = _interopRequireDefault(require("./word"));
var _sentence = _interopRequireDefault(require("./sentence"));
var _faq_item = _interopRequireDefault(require("./faq_item"));
var _feedback = _interopRequireDefault(require("./feedback"));
var _site_release = _interopRequireDefault(require("./site_release"));
var _concept = _interopRequireDefault(require("./concept"));
var _exercise_basic = _interopRequireDefault(require("./exercise_basic"));
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var ForumThread = (_dec = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec2 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec3 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec4 = (0, _serializr.serializable)((0, _serializr.object)(_worksheet_basic["default"])), _dec5 = (0, _serializr.serializable)((0, _serializr.object)(_exercise_basic["default"])), _dec6 = (0, _serializr.serializable)((0, _serializr.object)(_user["default"])), _dec7 = (0, _serializr.serializable)((0, _serializr.object)(_word["default"])), _dec8 = (0, _serializr.serializable)((0, _serializr.object)(_faq_item["default"])), _dec9 = (0, _serializr.serializable)((0, _serializr.object)(_sentence["default"])), _dec10 = (0, _serializr.serializable)((0, _serializr.object)(_concept["default"])), _dec11 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_comment["default"]))), _dec12 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_site_release["default"]))), _dec13 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_feedback["default"]))), _class = /*#__PURE__*/function (_RootModel) {
  function ForumThread() {
    var _this;
    _classCallCheck(this, ForumThread);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ForumThread, [].concat(args));
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _initializerDefineProperty(_this, "title", _descriptor2, _this);
    _initializerDefineProperty(_this, "body", _descriptor3, _this);
    _initializerDefineProperty(_this, "commentsCount", _descriptor4, _this);
    _initializerDefineProperty(_this, "visibleCommentsCount", _descriptor5, _this);
    _initializerDefineProperty(_this, "userId", _descriptor6, _this);
    _initializerDefineProperty(_this, "forumId", _descriptor7, _this);
    _initializerDefineProperty(_this, "siteId", _descriptor8, _this);
    _initializerDefineProperty(_this, "hidden", _descriptor9, _this);
    _initializerDefineProperty(_this, "updated", _descriptor10, _this);
    _initializerDefineProperty(_this, "pinned", _descriptor11, _this);
    _initializerDefineProperty(_this, "showInThread", _descriptor12, _this);
    _initializerDefineProperty(_this, "tag", _descriptor13, _this);
    _initializerDefineProperty(_this, "seenByAdmin", _descriptor14, _this);
    _initializerDefineProperty(_this, "slug", _descriptor15, _this);
    _initializerDefineProperty(_this, "referralRoute", _descriptor16, _this);
    _initializerDefineProperty(_this, "referralParams", _descriptor17, _this);
    _initializerDefineProperty(_this, "lastCommentName", _descriptor18, _this);
    _initializerDefineProperty(_this, "languageId", _descriptor19, _this);
    _initializerDefineProperty(_this, "createdAt", _descriptor20, _this);
    _initializerDefineProperty(_this, "updatedAt", _descriptor21, _this);
    _initializerDefineProperty(_this, "lastCommentedAt", _descriptor22, _this);
    _initializerDefineProperty(_this, "worksheet", _descriptor23, _this);
    _initializerDefineProperty(_this, "exercise", _descriptor24, _this);
    _initializerDefineProperty(_this, "user", _descriptor25, _this);
    _initializerDefineProperty(_this, "word", _descriptor26, _this);
    _initializerDefineProperty(_this, "faqItem", _descriptor27, _this);
    _initializerDefineProperty(_this, "sentence", _descriptor28, _this);
    _initializerDefineProperty(_this, "concept", _descriptor29, _this);
    _initializerDefineProperty(_this, "comments", _descriptor30, _this);
    _initializerDefineProperty(_this, "siteReleases", _descriptor31, _this);
    _initializerDefineProperty(_this, "feedbacks", _descriptor32, _this);
    return _this;
  }
  _inherits(ForumThread, _RootModel);
  return _createClass(ForumThread, [{
    key: "referralParamsCamelCase",
    get: function get() {
      var _this2 = this;
      if ((0, _utils.isPresent)(this.referralParams)) {
        var obj = {};
        var paramKeys = (0, _lodash.keys)(this.referralParamsJson);
        (0, _lodash.each)(paramKeys, function (key) {
          var value = _this2.referralParamsJson[key];
          obj[(0, _lodash.camelCase)(key)] = value;
        });
        return obj;
      }
      return {};
    }
  }, {
    key: "referralParamsJson",
    get: function get() {
      return JSON.parse(this.referralParams);
    }
  }, {
    key: "hasWorksheet",
    get: function get() {
      return (0, _utils.isPresent)(this.worksheet);
    }
  }, {
    key: "titleOrTarget",
    get: function get() {
      return (0, _utils.isPresent)(this.target) ? this.target : this.title;
    }
  }, {
    key: "target",
    get: function get() {
      if ((0, _utils.isPresent)(this.word)) {
        return this.word.targetTextWithDefiniteArticle;
      }
      if ((0, _utils.isPresent)(this.sentence)) {
        return this.sentence.targetText;
      }
      if ((0, _utils.isPresent)(this.concept)) {
        return this.concept.name;
      }
      return null;
    }
  }, {
    key: "answer",
    get: function get() {
      return this.sentence && (0, _utils.isPresent)(this.sentence.answers) ? this.sentence.answers[0] : null;
    }
  }, {
    key: "source",
    value: function source(user) {
      if ((0, _utils.isPresent)(this.word) && (0, _utils.isPresent)(this.word.vocabSourceListForUser(user))) {
        return this.word.vocabSourceListForUser(user).join(', ');
      }
      if ((0, _utils.isPresent)(this.sentence)) {
        return this.sentence.sourceTextForUser(user);
      }
      return null;
    }
  }, {
    key: "filteredCommentsCount",
    value: function filteredCommentsCount(user) {
      return this.comments.filter(function (item) {
        return !item.hidden || item.user.id === user.id || user.admin;
      }).length;
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "title", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "body", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "commentsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "visibleCommentsCount", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "userId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "forumId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "siteId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "hidden", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "updated", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "pinned", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "showInThread", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "tag", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "seenByAdmin", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "slug", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "referralRoute", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "referralParams", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "lastCommentName", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "languageId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_mobx.observable, _dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "updatedAt", [_mobx.observable, _dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "lastCommentedAt", [_mobx.observable, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "worksheet", [_mobx.observable, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "exercise", [_mobx.observable, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "user", [_mobx.observable, _dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "word", [_mobx.observable, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "faqItem", [_mobx.observable, _dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "sentence", [_mobx.observable, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "concept", [_mobx.observable, _dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "comments", [_mobx.observable, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "siteReleases", [_mobx.observable, _dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "feedbacks", [_mobx.observable, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "referralParamsCamelCase", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "referralParamsCamelCase"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "referralParamsJson", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "referralParamsJson"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasWorksheet", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasWorksheet"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "titleOrTarget", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "titleOrTarget"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "target", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "target"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "answer", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "answer"), _class.prototype), _class);
var _default = exports["default"] = ForumThread;